// トップスライダーの起動 // Launch the top slider

const swiper = new Swiper(".p-topSeminar__swiper", {
  speed: 1000, // スライド変化時間
  loop: true,
  loopAdditionalSlides: 1,
  slidesPerView: 2,
  spaceBetween: 10,
  autoplay: {
    delay: 4500, //　スライダー表示時間
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    type: "bullets",
    clickable: true,
  },
  breakpoints: {
    769: {
      slidesPerView: 3,
    },
    1025: {
      slidesPerView: 4,
    },
  },
});

jQuery(function ($) {
  if (sessionStorage.getItem("fmhr-loading") === null) {
    // 初回表示

    // Loading表示
    var h = $(window).height();
    $("#loader-bg ,#loader").height(h).css("display", "block");
    $("#logo-loader").fadeIn(1000);
    setTimeout("stopload()", 3000);

    // WebStorageにfmhr-loading設定
    sessionStorage.setItem("fmhr-loading", "on");
  } else {
    // 2回目以降
    $(".p-topFv .catch_copy").removeClass("init_hide");
  }
});

jQuery(function ($) {
  $("#wrap").css("opacity", "1");
  $("#loader-bg").delay(1000).fadeOut(1000);
  $("#loader").delay(1000).fadeOut(1000);
  $("#logo-loader").fadeOut(2000);
  $(".p-topFv .catch_copy").removeClass("init_hide");
});
